export enum ETenantUrl {
  TENANT = 'tenant/api/v2',
}
